<div class="app-open-items-container"
     data-testid="open-items-container"
     role="main"
     aria-label="Open items management">
  <schedule-detail-header [title]="'Open Items'"
                          [backLabel]="'Lot'"
                          [subtitle]="headerSubtitle()"
                          [backCallback]="goBack.bind(this)"
                          [showCloud]="true"
                          [isRefreshingInBackground]="isRefreshingInBackground()">
    <ng-container header-right>
      <button type="button"
              class="lot-kebab-btn"
              aria-label="Item list options"
              data-testid="open-items-btn-kebab"
              (click)="openItemsMenu()">
        <i class="pi pi-ellipsis-v"></i>
      </button>
    </ng-container>
  </schedule-detail-header>

  <tab-bar [options]="tabOptions"
           [initialValue]="currentTab()"
           (onTabChanged)="onTabChanged($event)"
           data-testid="cm-container-tab-buttons">
  </tab-bar>

  <app-header [selectedFiltersCount]="selectedFiltersCount()"
              [areAllSelected]="areAllIssuesSelected()"
              (onCollapseItemsToggle)="onCollapseItemsToggle($event)"
              (onShowFilter)="showFilterPanelSheet.set(true)"
              (onAddItem)="onAddItem()"
              (onSelectAll)="onSelectAll()">
    @if (activeFilterChips().length > 0) {
      <div class="filter-chip-row"
           (wheel)="onChipRowWheel($event)"
           data-testid="filter-chip-row">
        @for (chip of activeFilterChips(); track chip.filterId + chip.value) {
          <p-chip [label]="chip.displayLabel"
                  [removable]="true"
                  [removeIcon]="'pi pi-times'"
                  styleClass="filter-active-chip"
                  (onRemove)="onFilterChipRemove(chip)" />
        }
      </div>
    }
  </app-header>

  <div class="app-open-items"
       data-testid="open-items-content"
       role="region"
       aria-label="Issues list">
    <div class="issues-list"
         data-testid="issues-list">
      @if (loading()) {
        <div class="skeleton-container"
             data-testid="loading-issues"
             role="status"
             aria-live="polite"
             aria-label="Loading issues">
          <p-skeleton height="6rem"></p-skeleton>
          <p-skeleton height="6rem"></p-skeleton>
          <p-skeleton height="6rem"></p-skeleton>
          <p-skeleton height="6rem"></p-skeleton>
          <p-skeleton height="6rem"></p-skeleton>
          <p-skeleton height="6rem"></p-skeleton>
        </div>
      } @else if (filteredIssues().length === 0) {
        <div class="no-issues"
             data-testid="no-issues"
             role="status"
             aria-live="polite">
          <p>No issues found matching the current filters.</p>
        </div>
      } @else {
        <div class="issues-container"
             data-testid="issues-container"
             role="list"
             [class.search-spotlight-active]="!!spotlightIssueId()"
             [appDataUpdatedFade]="dataUpdatedPulse()"
             [attr.aria-label]="'Issues list with ' + filteredIssues().length + ' items'">
          @for (issue of filteredIssues(); track issue.id) {
            <app-issue-item [issue]="issue"
                            [isChecked]="issueCheckedMap()[issue.identifier] || false"
                            [isExpanded]="issuesExpandedMap()[issue.identifier] || false"
                            [openItemsSelectionType]="currentTab()"
                            [isCollapsed]="areIssuesCollapsed()"
                            [checkedVendorContactsMap]="checkedContactMapPerVendor()"
                            (onIssueChecked)="onIssueChecked($event, issue)"
                            (onIssueExpanded)="onIssueExpanded($event, issue)"
                            (onContactSelectionChange)="onContactSelectionChange($event)"
                            [attr.data-testid]="'issue-item-' + issue.id"
                            [class.search-spotlight-target]="issue.id === spotlightIssueId()">
            </app-issue-item>
          }
        </div>
      }
    </div>
  </div>

  <div class="open-items-footer">
    <app-horizontal-button-group class="footer-buttons"
                                 [buttons]="footerButtons()"
                                 [testId]="'open-items-footer-buttons'" />
  </div>

  <app-standard-bottom-sheet [(isOpen)]="showMoreActionsSheet"
                             [hasFooter]="false"
                             testId="show-more-actions-sheet">
    <app-vertical-button-group [buttons]="moreActionsButtons()"
                               class="more-actions-drawer"
                               testId="more-actions-drawer" />
  </app-standard-bottom-sheet>

  <!-- TODO -->
  <app-assign-room-bottom-sheet [(isOpen)]="showAssignRoomSheet"
                                [selectedIssueCount]="loading() ? 0 : selectedIssues().length"
                                (roomAssigned)="onRoomAssigned($event)">
  </app-assign-room-bottom-sheet>

  <app-add-new-item-bottom-sheet [lotId]="lotId()"
                                 [(isOpen)]="showAddNewItemSheet"
                                 (itemAdded)="onNewItemAdded($event)"
                                 data-testid="open-items-add-new-item-sheet">
  </app-add-new-item-bottom-sheet>

  <!-- TODO -->
  <app-assign-items-to-trade-bottom-sheet [(isOpen)]="showAssignItemsToTradeSheet"
                                          [selectedIssues]="loading() ? [] : selectedIssues()"
                                          (assigned)="onBulkVendorAssignment()"
                                          data-testid="assign-items-to-trade-sheet">
  </app-assign-items-to-trade-bottom-sheet>

  <app-filter-panel [(isOpen)]="showFilterPanelSheet"
                    [items]="loading() ? [] : issuesWithDetails()"
                    [definitions]="filterService.definitions"
                    [selected]="filterService.selected()"
                    itemNoun="item"
                    (applied)="onFiltersApplied($event)">
  </app-filter-panel>

  <app-bottom-sheet [(isOpen)]="isItemsMenuOpen"
                    [contentTemplate]="itemsMenuTemplate"
                    [hasFooter]="false"
                    [isFullScreen]="false"
                    [preventOverlayClose]="false"
                    data-testid="open-items-sheet-items-menu" />

  <ng-template #itemsMenuTemplate>
    <div class="lot-menu-sheet"
         data-testid="open-items-container-items-menu">
      <p-button label="Completed Items"
                severity="contrast"
                class="lot-menu-sheet-btn"
                data-testid="open-items-btn-navigate-completed"
                (onClick)="navigateToCompletedItems()" />
    </div>
  </ng-template>
</div>